export class SoundConstants {
    static readonly BASE_MUSIC = 'base_music_loop';
    static readonly FREEGAME_MUSIC = 'free_background_loop';
    static readonly INTRO_MUSIC = 'Intro_transition';
    static readonly INTRO_TRANSITION = 'thunder_transition';
    static readonly REELS_SPIN = 'reels_spinning';
    static readonly REEL_STOP = 'reel_stop';
    static readonly SCATTER_TRIGGER = 'Scatter_Trigger';
    static readonly SCATTER_LAND = 'scatter_land';
    static readonly BUTTON_CLICK = 'click';
    static readonly BET_LEVEL = "bet-level";
    static readonly TOTAL_WIN = "total_win";
    static readonly TOTAL_WIN_END = "total_win_end";
    static readonly GOD_SYMBOL_FLIP = "god_symbol_flip";
    static readonly GOD_SYMBOL_FIRING = "god_symbol_firing";
    static readonly ANTICIPATION_LOOP = "scatter_anticipation_loop";
    static readonly SYMBOL_WIN = "symbol_win";
    static readonly BIG_WIN_LOOP = "win_loop";
    static readonly WIN_TICKUP = "win_tickup";
    static readonly WIN_TICKUP_END = "win_tickup_end";
    static readonly FEATURE_BANNER = "free_Game_Banner";
    static readonly BIG_WIN = "Big_Win_Transition";
    static readonly MEGA_WIN = "Mega_Win_Transition";
    static readonly SUPER_WIN = "Super_Win_Transition";
    static readonly EPIC_WIN = "Epic_Win_Transition";
    static readonly BANNER_TRANSITION = "lightning_strike";
    static readonly HADES = "hades";
    static readonly ZEUS = "zeus";
    static readonly OCEAN = "ocean";
    static readonly ANTICIPATION_SOUND = "3_last_slots";
    static readonly INFERNO_DOUBLE = "inferno_double";
    static readonly OCEAN_F = "ocean_multipliers_flying_to_be_collected";
    static readonly ZEUS_F = "lightning_strike_increasing_multipliers";
    static readonly HADE_F = "inferno_double_doubling_multipliers";
    static readonly FINAL_MULTIPLIERS_COLLECT = "final_count_increasing";
}